import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import '../styles/loading.style.css';
import logo from '../assets/images/logo.png';
import mascotEmpty from '../assets/images/mascot-empty.png';
import starGreen from '../assets/images/star-green.svg';
import starPink from '../assets/images/star-pink.svg';
import hairRedLeft from '../assets/images/hair-red-left.svg';
import hairRedRight from '../assets/images/hair-red-right.svg';
import mascotFace from '../assets/images/mascot-face.png';
import scoutoutLogo from '../assets/images/scoutout-logo.png';
import footerSVG from '../assets/images/footer.svg';

const LoadingPage = () => {
    const navigate = useNavigate();
    const { t } = useLanguage();
    
    useEffect(() => {
        const timer = setTimeout(() => {
            navigate('/quiz');
        }, 3000);
        
        return () => clearTimeout(timer);
    }, [navigate]);
    
    return (
        <div className='container'>
            <div className='container-fluid-loading'>
                <div className='loading-page'>
                    <img src={logo} alt='logo' className='logo-white' />
                    <h1 className='head-title-process-result' dangerouslySetInnerHTML={{ __html: t('home.title') }}></h1>
                        <h1 className='head-title-process-result-2' dangerouslySetInnerHTML={{ __html: t('home.title2') }}></h1>
                        <img src={footerSVG} alt='footerSVG' className='footer-svg' />
                    <div className='mascot-control-loading'>
                        <img src={starGreen} alt='starGreen' className='star-green-loading' />
                        <img src={starPink} alt='starPink' className='star-pink-loading' />
                        <img src={mascotEmpty} alt='mascot' className='mascot-img-loading' />
                        <img src={hairRedLeft} alt='hairRedLeft' className='hair-red-left' />
                        <img src={hairRedRight} alt='hairRedRight' className='hair-red-right' />
                        <img src={mascotFace} alt='mascotFace' className='mascot-face-img-loading' />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default LoadingPage